export default {
  assetNotSupported: '{assetDisplayName} nie jest przypisany do źródła danych lub nie ma własnego widoku w Remote Control.',
};
